module.exports = __webpack_public_path__ + "resources/icon_50_left_arrow_small.c7b4042ac9273eff.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_50_left_arrow_small.png
// module id = 443
// module chunks = 0 1 2 3 4